import { FC } from "react";
import { Popover } from "antd";
import styled from "styled-components";
import { useHistory } from "react-router";
import { useCookies } from "react-cookie";
import store from "store";
import { logOut } from "modules/Login/action";
import { XIQ_ONLINE_URL } from "constants/index";

const Content: FC = (props) => {
  const history = useHistory();
  // getting remove method from useCookies
  const [cookies, setCookie, removeCookie] = useCookies([]);

  const handleLogout = () => {
    removeCookie("access_id");
    let now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth();
    let day = now.getDate();
    let cookieExpiry = new Date(year + 1, month, day);
    let domain = ".xiqonline.com";
    if (window.location.hostname === "localhost") {
      domain = "localhost";
    }
    setCookie("isLogout", "1", {
      path: "/",
      expires: cookieExpiry,
      domain: domain,
    });
    localStorage.setItem("isListView", "false");
    logOut().finally(() => {
      localStorage.removeItem("csrfToken");
      store.dispatch({ type: "USER_LOGOUT" });
      let hostName = window.location.hostname;
      // if not localhost redirect to WebApp - workbench login screen
      if (hostName !== "localhost") {
        window.location.href = `${XIQ_ONLINE_URL}auth/login?redirectURL=${window.location.origin}`;
      } else {
        history.push(""); // redirect to login page
        window.location.reload();
      }
    });
  };
  return (
    <ContentWrapper className="d-flex" onClick={handleLogout}>
      <span>Logout</span>
    </ContentWrapper>
  );
};

const ContentWrapper = styled.li`
  padding: 5px 10px;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
    padding: 0px 5px;
  }
  :hover {
    cursor: pointer;
  }
`;

const LogoutPopover: FC = (props) => {
  return (
    <Popover placement="rightBottom" content={Content} trigger="hover">
      {props.children}
    </Popover>
  );
};

export default LogoutPopover;
